  <template>
  <!-- <<< Dashboard >>> -->
  <div v-if="db_isSimple" class="iframe-container">
    <split-pane split="vertical" :default-percent='38' class="pos-rel">
      <div slot="paneL" class="pos-rel">
        <iframe class='split-iframe' name="-HotList-" id="-HotList-" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardSimple-&iList=-HotList-&iAppHostIP=209.200.78.201" />
      </div>
      <div slot="paneR" class="pos-rel">
        <iframe class='split-iframe' name="Property" id="Property" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardSimple-&iList=Property&iAppHostIP=209.200.78.201" />
      </div>
    </split-pane>
  </div>
  <div v-else-if="db_isLease" class="iframe-container">
    <split-pane split="vertical" :default-percent='25' class="pos-rel">
      <div slot="paneL" class="pos-rel">
        <iframe class='split-iframe' name="-HotList-" id="-HotList-" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardSimple-&iList=-HotList-&iAppHostIP=209.200.78.201" />
      </div>
      <div slot="paneR" class="pos-rel">
        <split-pane split="vertical" :default-percent='33' class="pos-rel">
          <div slot="paneL" class="pos-rel">
            <iframe class='split-iframe' name="Property" id="Property" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardSimple-&iList=Property&iAppHostIP=209.200.78.201" />
          </div>
          <div slot="paneR" class="pos-rel">
            <split-pane split="vertical" :default-percent='50' class="pos-rel">
              <div slot="paneL" class="pos-rel">
                <split-pane split="horizontal" :default-percent='50' class="pos-rel">
                  <div slot="paneL" class="pos-rel">
                    <iframe class='split-iframe' name="[LeaseTR]" id="[LeaseTR]" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=[LeaseTR]&iAppHostIP=209.200.78.201" />
                  </div>
                  <div slot="paneR" class="pos-rel">
                    <iframe class='split-iframe' name="[LeaseTROffer]" id="[LeaseTROffer]" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=[LeaseTROffer]&iAppHostIP=209.200.78.201" />
                  </div>
                </split-pane>
              </div>
              <div slot="paneR" class="pos-rel">
                <split-pane split="horizontal" :default-percent='50' class="pos-rel">
                  <div slot="paneL" class="pos-rel">
                    <iframe class='split-iframe' name="[LeaseLR]" id="[LeaseLR]" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=[LeaseLR]&iAppHostIP=209.200.78.201" />
                  </div>
                  <div slot="paneR" class="pos-rel">
                    <iframe class='split-iframe' name="[LeaseLROffer]" id="[LeaseLROffer]" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=[LeaseLROffer]&iAppHostIP=209.200.78.201" />
                  </div>
                </split-pane>
              </div>
            </split-pane>
          </div>
        </split-pane>
      </div>
    </split-pane>
  </div>
  <div v-else-if="db_isSale" class="iframe-container">
    <split-pane split="vertical" :default-percent='20' class="pos-rel">
      <div slot="paneL" class="pos-rel">
        <iframe class='split-iframe' name="-HotList-" id="-HotList-" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardSimple-&iList=-HotList-&iAppHostIP=209.200.78.201" />
      </div>
      <div slot="paneR" class="pos-rel">
        <split-pane split="vertical" :default-percent='25' class="pos-rel">
          <div slot="paneL" class="pos-rel">
            <iframe class='split-iframe' name="Property" id="Property" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardSimple-&iList=Property&iAppHostIP=209.200.78.201" />
          </div>
          <div slot="paneR" class="pos-rel">
            <split-pane split="vertical" :default-percent='33' class="pos-rel">
              <div slot="paneL" class="pos-rel">
                <split-pane split="horizontal" :default-percent='50' class="pos-rel">
                  <div slot="paneL" class="pos-rel">
                    <iframe class='split-iframe' name="InvestmentSale" id="InvestmentSale" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=InvestmentSale&iAppHostIP=209.200.78.201" />
                  </div>
                  <div slot="paneR" class="pos-rel">
                    <iframe class='split-iframe' name="InvestmentSaleOffer" id="InvestmentSaleOffer" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=InvestmentSaleOffer&iAppHostIP=209.200.78.201" />
                  </div>
                </split-pane>
              </div>
              <div slot="paneR" class="pos-rel">
                <split-pane split="vertical" :default-percent='50' class="pos-rel">
                  <div slot="paneL" class="pos-rel">
                    <split-pane split="horizontal" :default-percent='50' class="pos-rel">
                      <div slot="paneL" class="pos-rel">
                        <iframe class='split-iframe' name="SaleBR" id="SaleBR" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=SaleBR&iAppHostIP=209.200.78.201" />
                      </div>
                      <div slot="paneR" class="pos-rel">
                        <iframe class='split-iframe' name="SaleBROffer" id="SaleBROffer" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=SaleBROffer&iAppHostIP=209.200.78.201" />
                      </div>
                    </split-pane>
                  </div>
                  <div slot="paneR" class="pos-rel">
                    <split-pane split="horizontal" :default-percent='50' class="pos-rel">
                      <div slot="paneL" class="pos-rel">
                        <iframe class='split-iframe' name="SaleSR" id="SaleSR" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=SaleSR&iAppHostIP=209.200.78.201" />
                      </div>
                      <div slot="paneR" class="pos-rel">
                        <iframe class='split-iframe' name="SaleSROffer" id="SaleSROffer" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=SaleSROffer&iAppHostIP=209.200.78.201" />
                      </div>
                    </split-pane>
                  </div>
                </split-pane>
              </div>
            </split-pane>
          </div>
        </split-pane>
      </div>
    </split-pane>
  </div>
  <div v-else-if="db_isAll" class="iframe-container">
    <split-pane split="vertical" :default-percent='15' class="pos-rel">
      <div slot="paneL" class="pos-rel">
        <iframe class='split-iframe' name="-HotList-" id="-HotList-" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardSimple-&iList=-HotList-&iAppHostIP=209.200.78.201" />
      </div>
      <div slot="paneR" class="pos-rel">
        <split-pane split="vertical" :default-percent='18' class="pos-rel">
          <div slot="paneL" class="pos-rel">
            <iframe class='split-iframe' name="Property" id="Property" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardSimple-&iList=Property&iAppHostIP=209.200.78.201" />
          </div>
          <div slot="paneR" class="pos-rel">
            <split-pane split="vertical" :default-percent='20' class="pos-rel">
              <div slot="paneL" class="pos-rel">
                <split-pane split="horizontal" :default-percent='50' class="pos-rel">
                  <div slot="paneL" class="pos-rel">
                    <iframe class='split-iframe' name="InvestmentSale" id="InvestmentSale" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=InvestmentSale&iAppHostIP=209.200.78.201" />
                  </div>
                  <div slot="paneR" class="pos-rel">
                    <iframe class='split-iframe' name="InvestmentSaleOffer" id="InvestmentSaleOffer" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=InvestmentSaleOffer&iAppHostIP=209.200.78.201" />
                  </div>
                </split-pane>
              </div>
              <div slot="paneR" class="pos-rel">
                <split-pane split="vertical" :default-percent='25' class="pos-rel">
                  <div slot="paneL" class="pos-rel">
                    <split-pane split="horizontal" :default-percent='50' class="pos-rel">
                      <div slot="paneL" class="pos-rel">
                        <iframe class='split-iframe' name="SaleBR" id="SaleBR" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=SaleBR&iAppHostIP=209.200.78.201" />
                      </div>
                      <div slot="paneR" class="pos-rel">
                        <iframe class='split-iframe' name="SaleBROffer" id="SaleBROffer" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=SaleBROffer&iAppHostIP=209.200.78.201" />
                      </div>
                    </split-pane>
                  </div>
                  <div slot="paneR" class="pos-rel">
                    <split-pane split="vertical" :default-percent='33' class="pos-rel">
                      <div slot="paneL" class="pos-rel">
                        <split-pane split="horizontal" :default-percent='50' class="pos-rel">
                          <div slot="paneL" class="pos-rel">
                            <iframe class='split-iframe' name="SaleSR" id="SaleSR" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=SaleSR&iAppHostIP=209.200.78.201" />
                          </div>
                          <div slot="paneR" class="pos-rel">
                            <iframe class='split-iframe' name="SaleSROffer" id="SaleSROffer" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=SaleSROffer&iAppHostIP=209.200.78.201" />
                          </div>
                        </split-pane>
                      </div>
                      <div slot="paneR" class="pos-rel">
                        <split-pane split="vertical" :default-percent='50' class="pos-rel">
                          <div slot="paneL" class="pos-rel">
                            <split-pane split="horizontal" :default-percent='50' class="pos-rel">
                              <div slot="paneL" class="pos-rel">
                                <iframe class='split-iframe' name="[LeaseTR]" id="[LeaseTR]" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=[LeaseTR]&iAppHostIP=209.200.78.201" />
                              </div>
                              <div slot="paneR" class="pos-rel">
                                <iframe class='split-iframe' name="[LeaseTROffer]" id="[LeaseTROffer]" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=[LeaseTROffer]&iAppHostIP=209.200.78.201" />
                              </div>
                            </split-pane>
                          </div>
                          <div slot="paneR" class="pos-rel">
                            <split-pane split="horizontal" :default-percent='50' class="pos-rel">
                              <div slot="paneL" class="pos-rel">
                                <iframe class='split-iframe' name="[LeaseLR]" id="[LeaseLR]" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=[LeaseLR]&iAppHostIP=209.200.78.201" />
                              </div>
                              <div slot="paneR" class="pos-rel">
                                <iframe class='split-iframe' name="[LeaseLROffer]" id="[LeaseLROffer]" src="https://creator.zoho.com/ensobase/commrecrm/view-embed/ListPage4/?context=-dashboardAll-&iList=[LeaseLROffer]&iAppHostIP=209.200.78.201" />
                              </div>
                            </split-pane>
                          </div>
                        </split-pane>
                      </div>
                    </split-pane>
                  </div>
                </split-pane>
              </div>
            </split-pane>
          </div>
        </split-pane>
      </div>
    </split-pane>
  </div>
  <!-- <<< Wrapper >>> -->
  <iframe v-else-if="wr_isReports" class="maxframe" name="homeIframe" id="homeIframe" :src="wr_currentWrapperURL"></iframe>
  <iframe v-else-if="wr_isNewContact" class="maxframe" name="homeIframe" id="homeIframe" :src="wr_currentWrapperURL"></iframe>
  <iframe v-else-if="wr_isAllContacts" class="maxframe" name="homeIframe" id="homeIframe" :src="wr_currentWrapperURL"></iframe>
  <iframe v-else-if="wr_isNewProperty" class="maxframe" name="homeIframe" id="homeIframe" :src="wr_currentWrapperURL"></iframe>
  <iframe v-else-if="wr_isAllProperties" class="maxframe" name="homeIframe" id="homeIframe" :src="wr_currentWrapperURL"></iframe>
  <!-- <<< Taskmager >>> -->
  <div v-else-if="tm_taskmanager" class="iframe-container">
    <split-pane split="vertical" :default-percent='15' class="pos-rel">
      <div slot="paneL" class="pos-rel">
        <iframe class='split-iframe' :name="'tmContextFrame_' + this.tabObj.tab_id" :id="'tmContextFrameID_' + this.tabObj.tab_id" :src="tm_ctxWindow" />
      </div>
      <div slot="paneR" class="pos-rel">
        <split-pane split="vertical" :default-percent='45' class="pos-rel">
          <div slot="paneL" class="pos-rel">
            <iframe class='split-iframe' :name="'taskmanagerWindow_' + this.tabObj.tab_id" :id="'taskmanagerWindow_' + this.tabObj.tab_id" :src="tm_taskmanagerWindow" />
          </div>
          <div slot="paneR" class="pos-rel">
            <split-pane split="horizontal" :default-percent='50' class="pos-rel">
              <div slot="paneL" class="pos-rel">
                <iframe class='split-iframe' :name="'tskCal_' + this.tabObj.tab_id" :id="'tskCal_' + this.tabObj.tab_id" :src="tm_tskCal" />
              </div>
              <!-- ****************************** -->
              <div slot="paneR" class="pos-rel">
                <iframe class='split-iframe' :name="'tm3SubWin_' + this.tabObj.tab_id" :id="'tm3SubWin_' + this.tabObj.tab_id" :src="tm_tm3SubWin" />
              </div>
            </split-pane>
          </div>
        </split-pane>
      </div>
    </split-pane>
  </div>
</template>
<!-- <router-link to="/">/youtube.com</router-link> -->

<script>
export default {
  name: 'Wrapper',
  props: ['tabObj'],
  data: function () {
    //  <<< Dashboard >>>
    const dashboard = {
      db_isSimple: null,
      db_isLease: null,
      db_isSale: null,
      db_isAll: null
    }
    //  <<< Wrapper >>>
    const wrapper = {
      wr_isReports: null,
      wr_isNewContact: null,
      wr_isAllContacts: null,
      wr_isNewProperty: null,
      wr_isAllProperties: null
    }
    //  <<< Taskmanager >>>
    const taskmanager = {
      tm_taskmanager: null,
      tm_topParentName: null,
      tm_topParentID: null,
      tm_style: null,
      tm_cmd: null,
      tm_subFormAction: null,
      tm_iList: null,
      tm_formID: null,
      tm_formType: null,
      tm_iContactID: null
    }
    const allProperties = { ...dashboard, ...wrapper, ...taskmanager }
    return allProperties
  },
  created() {
    if (this.isThisTabActive) {
      // Active tab, load from live data
      //
      //  <<< Dashboard >>>
      if (this.tabObj.tab_type === 'Dashboard') {
        this.db_isSimple = this.get_isSimple(this.tabObj.tab_id)
        this.db_isLease = this.get_isLease(this.tabObj.tab_id)
        this.db_isSale = this.get_isSale(this.tabObj.tab_id)
        this.db_isAll = this.get_isAll(this.tabObj.tab_id)
      }
      //  <<< Wrapper >>>
      if (this.tabObj.tab_type === 'Wrapper') {
        this.wr_isReports = this.get_isReports(this.tabObj.tab_id)
        this.wr_isNewContact = this.get_isNewContact(this.tabObj.tab_id)
        this.wr_isAllContacts = this.get_isAllContacts(this.tabObj.tab_id)
        this.wr_isNewProperty = this.get_isNewProperty(this.tabObj.tab_id)
        this.wr_isAllProperties = this.get_isAllProperties(this.tabObj.tab_id)
      }
      //  <<< Taskmanager >>>
      if (this.tabObj.tab_type === 'Taskmanager') {
        this.tm_taskmanager = this.get_isTaskmanagerActive(this.tabObj.tab_type)
        this.tm_topParentName = this.get_topParentName()
        this.tm_topParentID = this.get_topParentID()
        this.tm_style = this.get_tm_style()
        this.tm_cmd = this.get_cmd()
        this.tm_subFormAction = this.get_subFormAction()
        this.tm_iList = this.get_iList()
        this.tm_formID = this.get_formID()
        this.tm_formType = this.get_formType()
        this.tm_iContactID = this.get_iContactID()
      }
    } else if (this.tabObj !== void 0) {
      // Inactive tab, load from memory
      //
      //  <<< Dashboard >>>
      if (this.tabObj.tab_type === 'Dashboard') {
        this.db_isSimple = this.get_isSimple(this.tabObj.tab_id)
        this.db_isLease = this.get_isLease(this.tabObj.tab_id)
        this.db_isSale = this.get_isSale(this.tabObj.tab_id)
        this.db_isAll = this.get_isAll(this.tabObj.tab_id)
      }
      //  <<< Wrapper >>>
      if (this.tabObj.tab_type === 'Wrapper') {
        this.wr_isReports = this.get_isReports(this.tabObj.tab_id)
        this.wr_isNewContact = this.get_isNewContact(this.tabObj.tab_id)
        this.wr_isAllContacts = this.get_isAllContacts(this.tabObj.tab_id)
        this.wr_isNewProperty = this.get_isNewProperty(this.tabObj.tab_id)
        this.wr_isAllProperties = this.get_isAllProperties(this.tabObj.tab_id)
      }
      //  <<< Taskmanager >>>
      if (this.tabObj.tab_type === 'Taskmanager') {
        const URLParams = getURLParams(this.tabObj.tab_fullPath)
        this.tm_taskmanager = this.get_isTaskmanagerActive(this.tabObj.tab_type)
        this.tm_topParentName = URLParams.topParentName
        this.tm_topParentID = URLParams.topParentID
        this.tm_style = URLParams.tm_style
        this.tm_cmd = URLParams.cmd
        this.tm_subFormAction = URLParams.subFormAction
        this.tm_iList = URLParams.iList
        this.tm_formID = URLParams.formID
        this.tm_formType = URLParams.formType
        this.tm_iContactID = URLParams.iContactID
      }
    }
  },
  methods: {
    //  <<< view type >>>
    get_isTaskmanagerActive(retVal) {
      return (retVal === void 0) ? '' : retVal.includes('Taskmanager')
    },
    get_isDashboard(retVal) {
      return (retVal === void 0) ? '' : retVal.includes('Dashboard')
    },
    get_isWrapper(retVal) {
      return (retVal === void 0) ? '' : retVal.includes('Wrapper')
    },
    //  <<< Dashboard >>>
    get_isSimple(retVal) {
      return (retVal === void 0) ? '' : retVal.includes('Dashboard-simple')
    },
    get_isLease(retVal) {
      return (retVal === void 0) ? '' : retVal.includes('Dashboard-lease')
    },
    get_isSale(retVal) {
      return (retVal === void 0) ? '' : retVal.includes('Dashboard-sale')
    },
    get_isAll(retVal) {
      return (retVal === void 0) ? '' : retVal.includes('Dashboard-all')
    },
    //  <<< Wrapper >>>
    get_isReports(retVal) {
      return (retVal === void 0) ? '' : retVal.includes('all-reports')
    },
    get_isNewContact(retVal) {
      return (retVal === void 0) ? '' : retVal.includes('new-contact')
    },
    get_isAllContacts(retVal) {
      return (retVal === void 0) ? '' : retVal.includes('all-contacts')
    },
    get_isNewProperty(retVal) {
      return (retVal === void 0) ? '' : retVal.includes('new-property')
    },
    get_isAllProperties(retVal) {
      return (retVal === void 0) ? '' : retVal.includes('all-properties')
    },
    //  <<< Taskmanager >>>
    get_topParentName() {
      const retVal = this.$route.query.topParentName
      return (retVal === void 0) ? '' : retVal.trim()
    },
    get_topParentID() {
      const retVal = this.$route.query.topParentID
      return (retVal === void 0) ? '' : retVal.trim()
    },
    get_tm_style() {
      const retVal = this.$route.query.style
      return (retVal === void 0) ? '' : retVal.trim()
    },
    get_cmd() {
      const retVal = this.$route.query.cmd
      return (retVal === void 0) ? '' : retVal.trim()
    },
    get_subFormAction() {
      const retVal = this.$route.query.subFormAction
      return (retVal === void 0) ? '' : retVal.trim()
    },
    get_iList() {
      const retVal = this.$route.query.iList
      return (retVal === void 0) ? '' : retVal.trim()
    },
    get_formID() {
      const retVal = this.$route.query.formID
      return (retVal === void 0) ? '' : retVal.trim()
    },
    get_formMyID() {
      const retVal = this.$route.query.formMyID
      return (retVal === void 0) ? '' : retVal.trim()
    },
    get_formType() {
      const retVal = this.$route.query.formType
      return (retVal === void 0) ? '' : retVal.trim()
    },
    get_iContactID() {
      const retVal = this.$route.query.iContactID
      return (retVal === void 0) ? '' : retVal.trim()
    }
  },
  computed: {
    isThisTabActive() {
      let retVal = null
      if (this.tabObj !== void 0) {
        retVal = (this.tabObj.tab_fullPath === this.$route.fullPath)
      }
      return retVal
    },
    isTaskmanagerActive() {
      const retVal = this.$route.name
      return (retVal === void 0) ? '' : retVal === 'Taskmanager'
    },
    wr_currentWrapperURL() {
      if (this.tm_taskmanager) { return null }

      const reports = 'https://creator.zoho.com/ensobase/commrecrm/#View:All_Contacts'
      const newContact = 'https://creator.zoho.com/ensobase/commrecrm/form-embed/Contacts/cmd=newFromHomeIcon'
      const allContacts = 'https://creator.zoho.com/ensobase/commrecrm/view-perma/All_Contacts'
      const newProperty = 'https://creator.zoho.com/ensobase/commrecrm/form-embed/Property/cmd=newFromHomeIcon'
      const allProperties = 'https://creator.zoho.com/ensobase/commrecrm/view-perma/All_Property/'

      let retVal = reports
      retVal = this.wr_isReports ? reports : retVal
      retVal = this.wr_isNewContact ? newContact : retVal
      retVal = this.wr_isAllContacts ? allContacts : retVal
      retVal = this.wr_isNewProperty ? newProperty : retVal
      retVal = this.wr_isAllProperties ? allProperties : retVal

      return retVal
    },
    //  <<< Taskmanager >>>
    tm_ctxWindow() {
      if (!this.tm_taskmanager) { return null }
      let url = 'https://creator.zoho.com/ensobase/commrecrm/view-perma/ListPage4/?context=-taskmanager-&iList='
      url += this.tm_iList + '&iAppHostIP=209.200.78.201' + '&formID=' + this.tm_formID + '&formType=' + this.tm_formType + '&iContactID=' + this.tm_iContactID
      return url
    },
    tm_taskmanagerWindow() {
      if (!this.tm_taskmanager) { return null }
      let url = 'https://creator.zoho.com/ensobase/commrecrm/view-perma/TaskManager/TopParentID='
      url += this.tm_topParentID + '&style=' + this.tm_style + '&cmd=' + this.tm_cmd
      return url
    },
    tm_tskCal() {
      if (!this.tm_taskmanager) { return null }
      let url = 'https://creator.zoho.com/ensobase/commrecrm/view-perma/zBlank?formID='
      url += this.tm_formID + '&formType=' + this.tm_formType
      return url
    },
    tm_tm3SubWin() {
      if (!this.tm_taskmanager) { return null }
      let url = 'https://creator.zoho.com/ensobase/commrecrm/view-perma/zBlank/'
      url += 'context=-taskmanager-'
      return url
    }
  }
}
// ======================================
// TODO import from utilities.js
let getURLParams = function (url) {
  // http://findnerd.com/list/view/How-to-convert-query-string-to-json-object-in-javascript/24201/
  const result = {}
  const searchIndex = url.indexOf('?')

  if (searchIndex === -1) return result
  const sPageURL = url.substring(searchIndex + 1)
  const sURLVariables = sPageURL.split('&')
  for (let i = 0; i < sURLVariables.length; i++) {
    const sParameterName = sURLVariables[i].split('=')
    result[sParameterName[0]] = decodeURIComponent(sParameterName[1]).trim()
  }
  return result
}
</script>

<style scoped>
/* <<< Dashboard >>> */
/* <<< Taskmanager >>> */
.horizontal-split-pane {
  height: 100%;
  /* overflow: auto; */
}
.vertical-split-pane {
  height: 100%;
  /* overflow: auto; */
}
.scroll {
  overflow: auto;
}
.pos-rel {
  position: relative;
  height: 100%;
}
/* <<< Wrapper >>> */
.liAnchor {
  white-space: nowrap;
  display: flex;
  white-space: nowrap;
  line-height: 22.44px;
}

.liAnchor:hover {
  text-decoration: none !important;
}

.ulMenuDD_Enso {
  margin-top: 0px;
  padding-top: 8px;
  padding-bottom: 10px;
  margin-left: 10px;
}

.ulMenuDDContent_Enso {
  margin-top: 6px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
}

.ndallMenuContainer li {
  padding: 0px;
  border-top: 1px solid #eee;
  /*border-bottom: 1px solid #eee;*/
  border-bottom: 0px;
  position: relative;
  margin-left: 6;
}

.ndallMenuContainer li:hover a {
  color: white;
  margin-top: 0px;
  /*box-shadow: 0 5px 10px rgba(0,0,0,0.3);*/
}

.ndbreadCrumb:hover {
  border-bottom: 1px;
  background-color: #6c6c6c;
  margin-top: 0px;
  padding-top: 7px;
  padding-bottom: 10px;
  /*box-shadow: 0 5px 10px rgba(0,0,0,0.3);*/
}

.homeToolbarHomeIcon {
  /*
    background: url('https://js.zohostatic.com/creator/ZOHOCREATOR_REVIEWED_Dec_02_2016_3/zohocreator/userhome/images/zc_userhome_bg.png') no-repeat;
    width: 12px;
    height: 11px;
    background-position: -0px -291px;
    */
  /* 7/20/17
    background: url('https://js.zohostatic.com/creator/ZOHOCREATOR_MARKETING_BRANCH_REVIEWED_Dec_28_2016/appedit/images/zc_appedit_bg.png') no-repeat;
    */
  /*
    1/9/18
    background: url('https://js.zohostatic.com/creator/24359/appedit/images/zc_appedit_bg.png') no-repeat;
    */
  background: url('https://firebasestorage.googleapis.com/v0/b/agendakit-1487098982147.appspot.com/o/static%2Flegacy%2Fzcicons.png?alt=media&token=af894573-9963-455c-a81a-876fc6cb59a3')
    no-repeat;
  width: 14px;
  height: 14px;
  background-position: -0px -186px;
}

/*overwrite zohodiscussion.css, body: min-width: 1000px;*/
body {
  min-width: auto !important;
}

#contentDiv2 {
  display: table-row;
  background-color: white;
}

.maxframe {
  position: absolute;
  border-width: 0px;
  width: 100vw;
  height: calc(100% - 8px);
  margin: 0px;
  padding: 0px;
}

.container {
  display: table;
  width: 100vw;
  height: 100%;
  /*border:9px dashed #ffd800;*/
}

#toolbarDiv1 {
  display: table-row;
  height: 30px;
  background-color: #444;
}
</style>
